/* ListHeader.tsx */
.listHeader {
  width: 100%;
  z-index: var(--z-indices-overlay);

  &:where([data-sticky]) {
    position: sticky;
    top: 0;
  }

  /* Nav variant */
  &:where([data-variant='nav']) {
    align-items: center;
    display: flex;
    min-width: 0;
    overflow: hidden;
    padding-left: var(--spaces-16);
    padding-right: var(--spaces-16);

    &:where([data-sticky]) {
      background: var(--colors-components-sheet-background);
    }
  }

  /* List variant */
  &:where([data-variant='list']) {
    align-items: center;
    background: var(--colors-background-panel);
    box-shadow: 0px 16px 40px rgb(0 0 0 / 0%);
    display: flex;
    min-width: 0;
    padding-left: var(--spaces-16);
    padding-right: var(--spaces-16);
    transition: box-shadow 0.2s ease;

    &:where([data-pinned]) {
      box-shadow: var(--colors-components-list-box-header-shadow);
    }
  }
}
